<script setup lang="ts">
const rewards = [
	{
		name: '100_pln_discount',
		subtextTranslated: '1500_cars',
		icon: 'ticket-discount',
	},
	{
		name: '200_pln_discount',
		subtextTranslated: '3000_cars',
		icon: 'ticket-discount',
	},
	{
		name: '300_pln_discount',
		subtextTranslated: '4500_cars',
		icon: 'ticket-discount',
	},
	{
		name: '400_pln_discount',
		subtextTranslated: '6000_cars',
		icon: 'ticket-discount',
	},
	{
		name: '500_pln_discount',
		subtextTranslated: '7500_cars',
		icon: 'ticket-discount',
	},
	{
		name: '1000_pln_discount',
		subtextTranslated: '15000_cars',
		icon: 'ticket-discount',
	},
	{
		name: 'possibility_to_return_a_dirty_car',
		subtextTranslated: '10500_cars',
		icon: 'ticket-discount',
	},
	{
		name: 'possibility_to_return_a_dirty_bus',
		subtextTranslated: '1500_cars',
		icon: 'ticket-discount',
	},
	{
		name: 'additional_driver',
		subtextTranslated: '1000_cars',
		icon: 'ticket-discount',
	},
	{
		name: 'delivery_of_the_car_within_cities',
		subtextTranslated: '1000_cars',
		icon: 'ticket-discount',
	},
	{
		name: 'return_of_the_car_within_the_cities',
		subtextTranslated: '900_cars',
		icon: 'ticket-discount',
	},
	{
		name: 'delivery_and_return_of_the_car',
		subtextTranslated: '1800_cars',
		icon: 'ticket-discount',
	},
	{
		name: 'migration_fee',
		subtextTranslated: '3000_cars',
		icon: 'ticket-discount',
	},
	{
		name: 'zone_1_abroad',
		subtextTranslated: '3000_cars',
		icon: 'ticket-discount',
	},
	{
		name: 'zone_2_abroad',
		subtextTranslated: '6000_cars',
		icon: 'ticket-discount',
	},
	{
		name: 'zone_3_abroad',
		subtextTranslated: '7500_cars',
		icon: 'ticket-discount',
	},
]
</script>

<template>
	<section class="rewards">
		<div class="rewards__container">
			<h2 data-aos="fade-up" class="rewards__title">
				{{ $t('modules.loyalty_program_module.loyalty_program_rewards.exchange_points_for_rewards') }}
			</h2>
			<p data-aos="fade-up" class="rewards__description">
				{{ $t('modules.loyalty_program_module.loyalty_program_rewards.start_your_journey_with') }}
			</p>
			<div data-aos="fade-up" class="rewards__items">
				<template v-for="(item, idx) in rewards" :key="idx">
					<LoyaltyProgramRewardsReward
						:name="item.name"
						:subtext="item.subtext"
						:subtextTranslated="item.subtextTranslated"
						:icon="item.icon" />
				</template>
			</div>
		</div>
	</section>
</template>

<style scoped lang="scss">
@import './LoyaltyProgramRewards.scss';
</style>
